module.exports = __webpack_public_path__ + "img/debit_card.d262c967.png";